import { api } from '../../api';

export interface ActiveLoginSession {
  id: string;
  deviceType: string;
  deviceName: string;
  browser: string;
  os: string;
  ipAddress: string;
  location: string;
  lastActivityAt: string;
  createdAt: string;
  isCurrent: boolean;
  portal?: string;
}

export interface ActiveLoginsResponse {
  message: string;
  data: ActiveLoginSession[];
  count: number;
}

export const ActiveLoginService = {
  getActiveSessions: async (): Promise<ActiveLoginsResponse> => {
    const response = await api.get<ActiveLoginsResponse>('/active-logins');
    return response.data;
  },

  terminateSession: async (sessionId: string) => {
    const response = await api.delete<{ message: string }>(`/active-logins/${sessionId}`);
    return response.data;
  },

  terminateAllOtherSessions: async () => {
    const response = await api.delete<{ message: string; terminatedCount: number }>(
      '/active-logins'
    );
    return response.data;
  },

  terminateAllSessions: async () => {
    const response = await api.delete<{ message: string }>('/active-logins/all');
    return response.data;
  },
};
